export default function StoreFilledIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.75 9c0-.07-.01-.14-.028-.206l-1.345-4.707A1.507 1.507 0 0 0 18.937 3H5.063a1.507 1.507 0 0 0-1.439 1.088L2.28 8.794A.74.74 0 0 0 2.25 9v1.5a3.75 3.75 0 0 0 1.5 3v6a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-6a3.75 3.75 0 0 0 1.5-3V9Zm-13.5 1.5a2.25 2.25 0 0 1-3.293 1.993.741.741 0 0 0-.17-.1A2.25 2.25 0 0 1 3.75 10.5v-.75h4.5v.75Zm6 0a2.25 2.25 0 0 1-4.5 0v-.75h4.5v.75Zm6 0a2.25 2.25 0 0 1-1.038 1.894.757.757 0 0 0-.169.098A2.25 2.25 0 0 1 15.75 10.5v-.75h4.5v.75Z"
      />
    </svg>
  );
}
